import {
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import Loading from "../loading";
import Snackbar from "../snackbar";
import { styles } from "./style";
import { is } from "immutable";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";
class ListPostCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      orderBy: "name",
      selected: [],
      message: "",
      id: 1,
      collapse: [],
      checked: [0],
      value: this.props.value || "",
    };
  }
  handleRequestSort = () => {
    let order = "desc";
    if (this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order });
  };

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState(
        { selected: this.props.list.map((item) => item.id) },
        function () {
          this.props.changeIdMenuArray(this.state.selected);
          this.props.id(this.state.selected); // send id to index => fetch list item menu
        }
      );
    } else {
      this.setState({ selected: [] });
      this.props.id();
      this.props.changeIdMenuArray([]);
    }
  };
  componentWillMount() {}
  async componentDidMount() {
    this.props.onRef(this);
    this.getListMultiLevel();
    // await this.props.getListMultiLevel()
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.id !== nextProps.id) {
      this.setState({ id: nextProps.id });
    }
  }

  getSorting(order, orderBy) {
    return order === "desc"
      ? (a, b) => this.desc(a, b, orderBy)
      : (a, b) => -this.desc(a, b, orderBy);
  }

  desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  handleOpenCollapes(id) {
    const collapse = this.state.collapse;
    if (collapse.indexOf(id) !== -1) collapse.splice(collapse.indexOf(id), 1);
    else collapse.push(id);
    this.setState(collapse);
  }

  isExist = (newSelected, x) => newSelected.indexOf(x) > -1;

  handleClick = (item) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(item.id);
    let subMenu = [];
    let newSelected = [];
    if (selectedIndex === -1) {
      subMenu = subMenu.concat(selected, item.id, this.getIdSubMenu(item));
      subMenu.forEach((element) => {
        if (!this.isExist(newSelected, element)) newSelected.push(element);
      });
    } else {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
      subMenu = this.getIdSubMenu(item);
      subMenu.forEach((element) => {
        if (newSelected.indexOf(element) !== -1) {
          newSelected = newSelected
            .slice(0, newSelected.indexOf(element))
            .concat(newSelected.slice(newSelected.indexOf(element) + 1));
        }
      });
    }
    this.setState({ selected: newSelected });
    this.props.id(newSelected);
    this.props.changeIdMenuArray(newSelected);
  };
  getIdSubMenu = (item) => {
    let newSelected = [];
    if (item.subMenu && item.subMenu.length > 0) {
      item.subMenu.forEach((element) => {
        newSelected = newSelected.concat(element.id);
        newSelected = newSelected.concat(this.getIdSubMenu(element));
      });
    }
    return newSelected;
  };
  checkSelected = (item) => {
    const { selected } = this.state;
    if (!item.subMenu && selected.indexOf(item.id) != -1) return true;
    else if (!item.subMenu && selected.indexOf(item.id) == -1) return false;
    let check = item.subMenu.map((item, index) => {
      return selected.indexOf(item.id) != -1 && this.checkSelected(item);
    });
    return check.indexOf(false) == -1 && selected.indexOf(item.id) != -1;
  };
  handleCheckCategory = (item) => {
    this.props.handleCheckCategory(item);
  };
  handleChange = (event) => {
    this.setState({ value: event.target.value });
  };
  getValue = () => {
    return this.state.value;
  };
  renderMenuItem = (item, menuLevel) => {
    const { classes } = this.props;
    const { selected, collapse } = this.state;
    const isSelected = this.checkSelected(item);
    let style = {
      cursor: "pointer",
      paddingLeft: `${menuLevel * 8 * 2}px`,
      borderBottom: "none",
    };
    return [
      <ListItem
        classes={{ container: classes.listItem }}
        style={style}
        key={`menu-${item.id}`}
        role={undefined}
        divider={true}
      >
        <RadioGroup
          aria-label="Gender"
          name="gender1"
          className={classes.group}
          value={this.state.value}
          onChange={this.handleChange}
        >
          <FormControlLabel
            value={item.id}
            label={item.name}
            control={
              <Radio
                color="default"
                name="radio-button-demo"
                inputProps={{ "aria-label": "E" }}
                icon={<RadioButtonUncheckedIcon fontSize="small" />}
                checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
              />
            }
          />
        </RadioGroup>
        {/* <ListItemText dense="true" primary={`${item.name}`} className={classes.listItemText}    onClick={() => this.handleOpenCollapes(item.id)}/> */}
        {/* {(item.subMenu && item.subMenu.fulfillmentValue.length>0 && collapse.indexOf(item.id)!=-1) && <ExpandLess  onClick={() => this.handleOpenCollapes(item.id)}/>}
                {(item.subMenu && item.subMenu.fulfillmentValue.length>0 && collapse.indexOf(item.id)==-1) && <ExpandMore  onClick={() => this.handleOpenCollapes(item.id)}/>} */}
        <ListItemSecondaryAction>
          <IconButton onClick={() => this.props.handleDeleteCategory(item)}>
            <CloseIcon className={classes.CloseIcon} />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>,
      item.subMenu &&
        item.subMenu.length > 0 &&
        item.subMenu.map((item) => {
          return this.renderMenuItem(item, menuLevel + 1);
        }),
    ];
  };
  getListMultiLevel = async () => {
    let { t } = this.props;
    this.loading.startLoading();
    let check = await this.props.getListMultiLevel();
    this.loading.stopLoading();
    if (check.code === 1 && !check.data.length) {
      this.props.handleEmptyList();
    } else if (check.code !== 1) {
      this.mSnackbar.handleClick(check.message, "error");
    }
    return check.data;
  };

  render() {
    const { classes, t, role, ownerCode, list } = this.props;
    const { selected, order, orderBy } = this.state;
    const rowCount = list.length;
    const numSelected = selected.length;

    return (
      <div>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <List className={classes.rootList} dense={true}>
          {list.sort(this.getSorting(order, orderBy)).map((row, index) => {
            return this.renderMenuItem(row, 1);
          })}
        </List>
      </div>
    );
  }
}

ListPostCategory.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  role: state.user.user.roleId.role,
  // listMenu: state.postCategory.listMultiLevel,
  ownerCode: state.service.service.userCode,
  list: state.postCategory.list,
});

const mapDispatch = (dispatch) => ({
  changeIdMenuArray: dispatch.postCategory.changeIdMenuArray,
  getListMultiLevel: dispatch.postCategory.getListMultiLevel,
});
export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(ListPostCategory)
  )
);
